// Lily pads: a couple of flat round green discs lying on the water surface, one
// with a small pink flower. Ported 1:1 from age-of-mcp's classic lily-pad.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [
    { geometry: new THREE.CylinderGeometry(0.22, 0.22, 0.03, 10),
      color: "#3f8f4a", position: [0, 0.02, 0] },
    { geometry: new THREE.CylinderGeometry(0.14, 0.14, 0.03, 9),
      color: "#4a9c52", position: [0.26, 0.02, 0.1] },
    // flower
    { geometry: new THREE.IcosahedronGeometry(0.06, 0),
      color: "#e6a8c4", position: [0, 0.07, 0] },
  ];
  return parts;
}

export const lilyPad = defineModel({
  id: "lily-pad",
  batchId: "standard",
  name: "Lily pad",
  tags: ["scenery","lily","pad","low-poly","age-of-mcp","classic","water"],
  summary: "Low-poly lily pad.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.34,
  parts: () => partsFor(),
  animations: [],
});
